import { Text } from '@/components';
import { Empty as AntdEmpty } from 'antd';
import type { CSSProperties, FC, ReactNode } from 'react';

type Props = {
  children?: ReactNode;
  description?: string;
  showDescription?: boolean;
  style?: CSSProperties;
  imageStyle?: CSSProperties;
};

/**
 * @see https://ant.design/components/empty#design-token
 */
export const Empty: FC<Props> = ({
  children,
  description,
  showDescription = true,
  style,
  imageStyle,
}) => {
  const descriptionElement = showDescription && description && (
    <Text text={description} weight="regular" color="secondary" />
  );

  return (
    <AntdEmpty
      image={AntdEmpty.PRESENTED_IMAGE_SIMPLE}
      imageStyle={imageStyle}
      description={descriptionElement}
      style={{ width: '100%', ...style }}
    >
      {children}
    </AntdEmpty>
  );
};
